import React from "react";

const OurMission = () => {
  return (
    <article className="about_our-mission">
      <img
        src="/images/about/ourMissionImg.jpg"
        className="our-mission-img"
        alt="Luxury homes - Our Mission - Helping you to become a successful entrepreneur in the short-term rental industry while providing amazing experiences to travelers finding a home away from home."
        width={1200}
        height={375}
      />
    </article>
  );
};

export default OurMission;
